import { Checkbox as MantineCheckbox } from "@mantine/core";

export const Checkbox = MantineCheckbox;
